import Vue from 'vue'

import withRender from './rating-stars.html'
import './rating-stars.scss'

export default withRender(Vue.extend({
  data() { return {} },
  props: {
    // text that is hidden from view, but accessible to screen readers.  Case where NOT to include
    // is reviews summary, where the info is redundant
    includeAccessibleText: {
      type: Boolean,
      default: true
    },
    rating: {
      type: Number,
      default: 0
    },
    starSize: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    adjustedRating() {
      const floorValue = Math.floor(this.rating)
      const rounded = Math.round(this.rating * 100) / 100
      const decimalValue = parseFloat((rounded - floorValue).toFixed(2))
      if (decimalValue < 0.25) {
        return floorValue
      } else if (decimalValue < 0.75) {
        return floorValue + 0.5
      }
      return floorValue + 1
    }
  },
  methods: {
    starIcon(starNum) {
      if (starNum > this.adjustedRating && starNum - this.adjustedRating >= 1) {
        return 'star--empty'
      } else if (starNum <= this.adjustedRating) {
        return 'star--full'
      }
      return 'star--half'
    }
  }
}))
